// import { initHeader } from './header';

import * as jq from 'jquery';
import { initMegaMenu } from './src/mega-menu';
import { initScrollingStatus } from './src/scrolling-status';
import { initHomeHero } from './src/home-hero';
import { initInsights } from './src/insights';
import { initScrollHelper, initScrollToNextStopButton } from './src/scroll-helper';
import { initScrollToTarget } from './src/scroll-to-target';
import { initScrollbar } from './src/scrollbar';
import { markFormSubmitted } from './src/form-submit';
import { initNewsletter } from './src/newsletter';

window['$'] = jq;
window['jQuery'] = jq;

class NetX {
	megaMenu = initMegaMenu;
	scrollingStatus = initScrollingStatus;
	homeHero = initHomeHero;
	insights = initInsights;
	scrollHelper = initScrollHelper;
	scrollToNextButton = initScrollToNextStopButton;
	scrollToTargetButton = initScrollToTarget;
	scrollbar = initScrollbar;
	formSubmitted = markFormSubmitted;
	newsletter = initNewsletter;
}


window['NetX'] = new NetX();
